module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2022/polkolonie/big/3-de2684122125d96e9c7447ea72c00c2c.webp";